import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import questions from "../../utils/translation/en.json";
import * as ReactBootstrap from "react-bootstrap";
import Button from "../../Button/Button";
import savedAnswerKeys from "./schema.json";
import ExitModalAndSave from "../Modal/ExitModalAndSave";
import { Container } from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import * as api from "../../api";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Loader from "react-loader-spinner";
import moment from "moment";
import {
  userChosenPropertyId,
  userChosenPropertyType,
  userChosenPropertyAddress,
  userChosenRepairLocationId,
  userChosenRepairLocation,
  userChosenHighLevelDescription,
  userChosenSupplementaryQuestions,
  userChosenAdditionalDescription,
  userChosenVandalismQuestion,
  userChosenVandalismAdditionalInformation,
  userChosenCovidQuestion,
  userChosenContactDetails,
  userChosenSTATUS,
  userChosenEligibilityErrorCode,
  userChosenContactPhone,
  userChosenContactName,
  userChosenRelationDetails,
  updatePrevConfirmedState,
  isEditState,
  backToRepairAsset,
  workOrderData,
  originalWorkOrderData,
  userChosenResumeRepair,
  loadDuplicateRepairPage,
  userChosenSaveExit,
  userChosenNotifyAll,
  userChosenDuplicateQuestion,
  userChosenVulnerabilityQuestion,
  dmcCheckSavedAnswer,
  isSaveAndExitAllowed,
  woFailureCase,
  saveAppointmentBundle
} from "../../ducks/redux/actions/userChoices";
import {
  getContractorName,
  workOrderRepairObject,
  getDeterminedContractorDetails,
  getContractorPayload,
  dmcWorkOrderRepairObject,
  getDMCDeterminedContractorDetails,
} from "../../ducks/redux/actions/getAddress";
import { WorksOrderRequest } from "../../models/WorksOrders/WorksOrderRequest";
import { CasePriority, RepairPriorityCode, AddressType } from "../../models/Repair/CreateRepair";
import { NoteType } from "../../models/Repair/Repair";
import { catalystTriageContractorType, EMAContractorType } from "../../models/Repair/Contractor";
import { PermissionsList } from "../../models/Permissions";
import { hasAR1Role } from "../../utils/GetRoles/permission";
import { RepairChannel } from "../../models/Repair/RepairChannel";
import { isNullOrUndefined, getDMCSorCodeReference } from "../../utils/formatting";
import { nanoid } from "nanoid";
import { RouteComponentProps } from "react-router-dom";
import { isUndefinedNullOrEmpty } from "../../utils/translation/helper";
import { Helper } from "../../utils/Helper/HelperUtil";
import { CASE_IDENTIFIER } from "../../ducks/redux/actionTypes";
import LoadingSpinner from "../../storybook/LoadingSpinner";
import { DeterminedContractorOptions } from "../../api";
import { saveHHSRSAssessmentCompleted } from "../../ducks/redux/actions/hazardAssessment";

interface ConfirmationDetailsProps extends RouteComponentProps<any> { }

const ConfirmationDetails: React.FC<ConfirmationDetailsProps> = (props) => {
  const savedResponses = useSelector((state: any) => state?.userChoicesReducer);
  const { t } = useTranslation();

  const dispatch = useDispatch();

  enum RepairCauseId {
    "General Wear and Tear" = 1,
    "Vandalism or Damage" = 4
  }

  enum AssetType {
    "Property" = "Property",
    "Block" = "Block",
  }

  const userChoosenDmcLocation = useSelector((state: any) => state?.userChoicesReducer?.userChosenDmcRepairLocation);
  const emailRedirect = useSelector((state: any) => state?.financialReferralReducer?.woRedirectFromEmail);
  const determinedcontractordetails = useSelector((state: any) => state?.addresses?.determinedcontractordetails);
  const userChosenSupplementaryQuestionsVal = useSelector((state: any) => state?.userChoicesReducer?.userChosenSupplementaryQuestions);
  const DMCChecksavedAnswervalue = useSelector((state: any) => state?.userChoicesReducer?.dmcCheckSavedAnswer);
  const workOrderObject = useSelector((state: any) => state?.addresses?.workOrderRepair);
  const originalWorkOrderObject = useSelector((state: any) => state?.userChoicesReducer?.originalWorkOrderData);
  const IsRecall = useSelector((state: any) => state?.userChoicesReducer?.IsRecall);
  const userChosenVandalismQuestionVal = useSelector((state: any) => state?.userChoicesReducer?.userChosenVandalismQuestion);
  const contractorname = useSelector((state: any) => state?.addresses?.contractorname);
  const userChosenCovidQuestionVal = useSelector((state: any) => state?.userChoicesReducer?.userChosenCovidQuestion);
  const repairDiagnosticFinalData = useSelector((state: any) => state?.userChoicesReducer?.repairDiagnosticFinalData);
  const isEnhancedDiagnosticsRepair = workOrderObject?.isEnhancedDiagnosticsRepair;
  const covidConfigValue = useSelector((state: any) => state?.userChoicesReducer?.isRepairCovidAllowed);
  const assetDetails = useSelector((state: any) => state?.dashboardReducer?.formState?.assetByIdDataObject);
  const vandalismConfigValue = useSelector((state: any) => state?.userChoicesReducer?.vandalismtoggleValue);
  const userChosenSOR = useSelector((state: any) => state?.userChoicesReducer?.userChosenSOR);
  const userMaintResp = useSelector((state: any) => state?.addresses?.maintresp);
  const userSelectedRepairResp = useSelector((state: any) => state?.addresses?.repairresp);
  const userVandalismChoice = useSelector((state: any) => state?.userChoicesReducer?.userChosenVandalismQuestion);
  const userChosenDuplicateQuestionFromStore = useSelector((state: any) => state?.userChoicesReducer?.userChosenDuplicateQuestion);
  const priority = useSelector((state: any) =>
    state?.dashboardReducer?.formState?.selectedRepairReasonPriorityOverride ??
    state?.dashboardReducer?.formState?.selectedRepairReasonObject?.[0]?.priority
  );
 
  const priorityCodeValue = useSelector((state: any) => state?.dashboardReducer?.formState?.priorityCode);
  const isDmcEnabledFlag = useSelector((state: any) => state?.userChoicesReducer?.isDMQuestionnaireEnabled);
  const isDMReportPreferenceEnabled = useSelector((state: any) => state?.userChoicesReducer?.isDMReportPreferenceEnabled);
  const selectedRepairReasonDefaultPriority = useSelector((state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonDefaultPriority);
  const isCatalyst = useSelector((state: any) => state?.userChoicesReducer?.isCatalystProperty);
  const isCatalystDefectTriageCase = isCatalyst && assetDetails?.statuses?.isInDefects === true
  const userChosenVulnerabilityQuestionFromStore = useSelector((state: any) => state?.userChoicesReducer?.userChosenVulnerabilityQuestion);
  const userChosenVulnerabilityAdditionalInformation = useSelector((state: any) => state?.userChoicesReducer?.userChosenVulnerabilityAdditionalInformation);
  const getPermissionsData = useSelector((state: any) => state?.userChoicesReducer?.userProfilePermissions);
  const isAR1User = hasAR1Role(getPermissionsData);
  const userChosenVandalismAdditionalInformationBackButton = useSelector((state: any) => state?.userChoicesReducer?.userChosenVandalismAdditionalInformation);
  const isRepairMedia = useSelector((state: any) => state?.userChoicesReducer?.isRepairMediaAllowed);
  const customerResponse = useSelector((state: any) => state?.addresses?.saveCustomerDetails);
  const customerAdditionalAlertData = useSelector((state: any) => state?.userChoicesReducer?.customerAdditionalAlertData);
  const dmcInspectionSorCodes = useSelector((state: any) => state?.userChoicesReducer?.dmcInspectionSorCodeValues);
  const vulnerabilityExcludedSorcodes = useSelector((state: any) => state?.userChoicesReducer?.vulnerabilityExcludedSorcodeValues);
  const selectedRepairReasonObject = useSelector((state: any) => state?.dashboardReducer?.formState?.selectedRepairReasonObject);
  const hazardResponses = useSelector((state: any) => state?.hazard?.responses || []);
  const hazardAssessmentOutcome = useSelector((state: any) => state?.hazard?.assessment);
  const isHHSRSAssessmentCompleted = useSelector((state: any) => state?.hazard?.isHHSRSAssessmentCompleted === true);
  const isHHSRSRepairEnabledCheck = useSelector((state: any) => state?.userChoicesReducer?.isHHSRSRepairEnabled);
  const preAssessmentJourneyQuestions = useSelector(
    (state: any) => state?.hazard?.preAssessmentJourneyQuestions
  );
  const getDMReportPreferenceValue = useSelector(
    (state: any) => state?.userChoicesReducer?.userChosenDMReportPreferenceValue// the email value is getting saved in this selector
  );
  const hhsrsSeverity = useSelector((state: any) => state?.financialReferralReducer?.saveSaverityScore)
  const hhsrsCategory = useSelector((state: any) => state?.financialReferralReducer?.saveHazardType)
  const hhsrsOption = useSelector((state: any) => state.financialReferralReducer?.saveHHSRSOptionValue);

  const isHHSRSEnabled = useSelector((state: any) => state?.financialReferralReducer?.isHHSRSEnabled)
  const isHHSRSRole = Array.isArray(getPermissionsData) && getPermissionsData.includes(PermissionsList.update_digital_journey_hhsrs_hazard_repair);
  const skipRespCheckForEMA = useSelector(
    (state: any) => state?.userChoicesReducer?.skipResponsibilityCheckForEMA
  );
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [isContractorLoading, setIsContractorLoading] = useState(true);
  const [editUrl, setEditUrl] = useState("");
  const duplicateOverridePermissions = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.workorder_override_duplicate_repairs) >= 0;
  const choosePriorityOfRepairPermission = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.workorder_choose_priority_of_repair) >= 0;
  const hideVulnerablePagePermission = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.workoder_vulnerable_hide_permission) >= 0;
  const reviewTriageRepairPermission = Array.isArray(getPermissionsData) && getPermissionsData.indexOf(PermissionsList.workorder_review_triage_repair) >= 0;
  const [dMCWOContractorResponse, setDMCWOContractorResponse] = useState<any | null>(null);
  const [dMCWOPriorityResponse, setDMCWOPriorityResponse] = useState<any | null>(null);
  const userChosenEmergencyQuestionVal = useSelector((state: any) => state?.userChoicesReducer?.userChosenEmergencyQuestion);
  let repairResp = assetDetails?.maintenanceResponsibilities?.find((resp: any) => resp.type === "REPINTREP")?.value ?? "";
  const dmcQuestionsFromReducer = useSelector((state: any) => state?.financialReferralReducer?.DMCData);
  const dmcAnswersFromReducer = useSelector((state: any) => state?.financialReferralReducer?.DMCAnsData);
  const configSOR = useSelector((state: any) => state?.financialReferralReducer?.sordamp);
  const hasSORToSkipCausingDMQues = getDMCSorCodeReference(configSOR, userChosenSOR);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingWOcreation, setIsLoadingWOcreation] = useState(false);
  const [disabled, setdisabled] = useState(true);
  const closeAfterSaving = false;
  const [showError, setShowError] = useState("");
  const [isTriageRepair, setIsTriage] = useState(true);
  const [isCatalystTriageTier2OrEma, setIsCatalystTriageTier2OrEma] = useState(false);
  const [contractorDeterminationResponse, setContractorDeterminationResponse] = useState<any>(null);
  const [disableContinueforEnhancedEligiblityCheck, setDisableContinueforEnhancedEligiblityCheck] = useState(false);
  const repairDiagnosticData = useSelector((state: any) => state?.userChoicesReducer?.repairDiagnosticFinalData);
  const isAdditionalDMWorkOrderRequired = useSelector((state: any) => state?.userChoicesReducer?.isAdditionalDMWorkOrderRequired);
  const WOCreationTimeoutSeconds = useSelector((state: any) => state?.userChoicesReducer?.woCreationTimeoutSeconds);
  const WOCreationPollingDelaySeconds = useSelector((state: any) => state?.userChoicesReducer?.woCreationPollingDelaySeconds);
  const customerDetails = useSelector((state: any) => state?.addresses?.saveCustomerDetails);
  const isHHRSReportPreferenceEnabled = useSelector((state: any) => state?.userChoicesReducer?.isHHRSReportPreferenceEnabled);// hhrs toggle to display preference question

  const startedRef = React.useRef(false);
  const pollAbortRef = React.useRef<(() => void) | null>(null);
  const sleep = (ms: number) => new Promise<void>(r => setTimeout(r, ms));
  type PollOpts = {
    workOrderId: string;
    timeoutMs: number;
    delayMs: number;
    immediateFirstAttempt?: boolean;
  };

  const enableHHRSPreference: boolean =
    isHHSRSRepairEnabledCheck === true && isHHRSReportPreferenceEnabled && isHHSRSAssessmentCompleted;
  

  const contractorSiteId: string | undefined =
    workOrderObject?.contractor;

  const isUnknownEmaTriage: boolean =
    !!contractorSiteId &&
    [
      EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE,
      EMAContractorType.UNKNOWN_EMA_TRIAGE,
    ].includes(contractorSiteId as any);

  const hasExistingDMCaseOrWO = useSelector((state: any) => state?.userChoicesReducer?.hasExistingDMCaseOrWO);
  type PollResult = { repair: any; attempts: number, outcome: any };
  type PollHandle = { promise: Promise<PollResult>; abort: () => void };

  const pollJobNumber = (opts: PollOpts): PollHandle => {
    const { workOrderId, timeoutMs, delayMs, immediateFirstAttempt } = opts;
    let aborted = false;
    let attempts = 0;

    const abort = () => { aborted = true; };

    const promise = (async (): Promise<PollResult> => {
      const start = Date.now();
      if (!immediateFirstAttempt) await sleep(delayMs);

      let latestRepairDetails: any = null;
      let woObjectUpdatedInDigiDB = false;

      while (!aborted && (Date.now() - start) < timeoutMs) {
        attempts++;
        try {
          const repair = await api.getRepair(workOrderId);
          latestRepairDetails = repair ?? latestRepairDetails;
          if (!woObjectUpdatedInDigiDB && !repair?.isDraft) {
            //Capture first isDraft saved in Database
            woObjectUpdatedInDigiDB = true;
          }

          const necErrorRolledBack = woObjectUpdatedInDigiDB && repair?.isDraft === true,
            jobNumberValue = repair?.jobNo;

          if (!isUndefinedNullOrEmpty(jobNumberValue)) {
            return { repair, attempts, outcome: "SUCCESS: Job Created" };
          } else if (necErrorRolledBack) {
            return { repair, attempts, outcome: "FAILURE: NEC Rollback" };
          }
        } catch { }
        const remaining = timeoutMs - (Date.now() - start);
        await sleep(Math.min(delayMs, remaining < 0 ? 0 : remaining));
      }
      return { repair: latestRepairDetails, attempts, outcome: "FAILURE: NEC Job not creation pending" };
    })();

    return { promise, abort };
  };


  const addDMNoteDefectRepair = (serialNumber: string, sequenceNumber: string) => {
    const risk = workOrderObject?.assessmentInformation?.outcome?.riskRating;
    let noteText = "";
    if (risk === CasePriority.Medium) {
      noteText = t("DMC_Inspection_Medium");
    } else if (risk === CasePriority.Low) {
      noteText = t("DMC_Inspection_Low");
    }
    if (!noteText) {
      console.warn(`No note text resolved for workOrderId ${workOrderObject?.id}, note not added`);
      return;
    }
    return api.postNoteForWorkorder(serialNumber, sequenceNumber, {
      noteTypeId: NoteType.Other,
      text: noteText,
    }).catch((e: any) => {
      console.warn(`Failed to post note (noteTypeId 3) for ${serialNumber}/${sequenceNumber} (workOrderId ${workOrderObject?.id})`, e);
      dispatch(
        woFailureCase(
          Helper.WOFailureMethod.DmcDefectPostNote,
          t("DMC_Failed_Defect_PostNote_Msg")
        )
      );
    });
  };

  const addNotesToDMCausingRepair = (serialNumber: any, sequenceNumber: any) => {
    if (
      !isTriageRepair && !isCatalystDefectTriageCase && !isCatalystTriageTier2OrEma
    ) {
      const noteTasks = [];
      //Add note to base repair (PRODAMP single DM, or non-PRODAMP when multi DM) for defect repair
      try {
        if (
          (hasSORToSkipCausingDMQues || (!!workOrderObject?.isCausingDampAndMould && !hasExistingDMCaseOrWO)) &&
          workOrderObject.premisesTypeId === 6 && //Property check
          workOrderObject?.isInDefect &&
          workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating !== CasePriority.High &&
          !workOrderObject?.isVandalism) {
          noteTasks.push(addDMNoteDefectRepair(serialNumber, sequenceNumber));
        }

        //Add note to PRODAMP repair for DM Report preference
        if (hasSORToSkipCausingDMQues) {
          noteTasks.push(addDMReportPreferenceNote(serialNumber, sequenceNumber));
        }

        Promise.all(noteTasks).catch(() => { });
      }
      catch (e) {
        console.error("add DM Notes post job creation failed", e);
      }
    }
  };

  const addDMReportPreferenceNote = async (serialNumber: string, sequenceNumber: string) => {
    let noteText = "",
      communicationPref = workOrderObject?.assessmentInformation?.communicationPreference,
      communicationEmailAddress = communicationPref?.addresses?.digitalAddresses?.[0]?.address;

    if (!isDMReportPreferenceEnabled) {
      console.warn(`DM Report Preference note disabled, note not added`);
      return;
    }
    if (communicationPref?.preferenceType === AddressType.Email && !isUndefinedNullOrEmpty(communicationEmailAddress)) {
      noteText = t("DM_ReportPreference_EmailAddress").replace("{EMAILADDRESS}", communicationEmailAddress);
    } else if (communicationPref?.preferenceType === AddressType.Postal) {
      noteText = t("DM_ReportPreference_CorrespondenceAddress");
    } else {
      console.warn(`No DM Report Preference note text resolved for workOrderId ${workOrderObject?.id}, note not added`);
      return;
    }

    api.postNoteForWorkorder(serialNumber, sequenceNumber, {
      noteTypeId: NoteType.Other,
      text: noteText,
    }).catch((e: any) => {
      console.warn(`Failed to post DM Report Preference note (noteTypeId 3) for ${serialNumber}/${sequenceNumber} (workOrderId ${workOrderObject?.id})`, e);
      dispatch(
        woFailureCase(
          Helper.WOFailureMethod.DmcDefectPostNote,
          t("DMC_Failed_Defect_PostNote_Msg")
        )
      );
    });
  };

  const addPreAssessmentNote = async (serialNumber: string, sequenceNumber: string) => {
    const preAssessmentIdentifier =
      workOrderObject?.assessmentInformation?.identifier || workOrderObject?.assessmentIdentifier;

    if (isHHSRSRepairEnabledCheck !== true || selectedRepairReasonObject?.[0]?.isPreAssessmentRequired !== true || !preAssessmentIdentifier) {
      return true;
    }

    try {
      let preAssessmentResponses = hazardResponses.filter(
        (response: any) => response.isPreAssessment && response.answerCodes?.length
      );
      let assessmentOutcome = hazardAssessmentOutcome;

      if (!preAssessmentResponses.length) {
        const diagnosticId = selectedRepairReasonObject?.[0]?.diagnosticId;
        if (
          diagnosticId === undefined ||
          diagnosticId === null ||
          !Array.isArray(preAssessmentJourneyQuestions)
        ) {
          return true;
        }

        const preAssessmentCategory = `${Helper.PreAssessment.CategoryPrefix}${diagnosticId}`;
        const savedAssessment = await api.getHazardAssessment(
          preAssessmentIdentifier
        );
        const questions = preAssessmentJourneyQuestions;
        preAssessmentResponses = savedAssessment?.responses?.map((savedResponse: any) => {
          const question = questions.find(
            (item: any) =>
              item.code === savedResponse.code &&
              Helper.isMatchingPreAssessmentCategory(item.category, preAssessmentCategory)
          );
          if (!question) {
            return null;
          }

          return {
            sequence: question.sequence,
            question: question.label,
            answers: [...question.options]
              .sort((first: any, second: any) => first.code.localeCompare(second.code, undefined, { numeric: true }))
              .filter((option: any) => savedResponse.answers?.includes(option.code))
              .map((option: any) => option.text),
          };
        }).filter(Boolean) || [];
        assessmentOutcome = {
          id: savedAssessment?.id,
          hazardType: savedAssessment?.hazardType,
          ...savedAssessment?.outcome,
        };
      }

      if (!preAssessmentResponses.length) {
        return true;
      }

      const noteLines = ["HHSRS Pre Assessment", ""];
      [...preAssessmentResponses]
        .sort((first: any, second: any) => first.sequence - second.sequence)
        .forEach((response: any, index: number) => {
          noteLines.push(
            `Question ${index + 1}: ${response.question}`,
            `Question ${index + 1} Answer(s): ${response.answers.join(", ")}`,
            ""
          );
        });

      const hazardType = assessmentOutcome?.hazardType || selectedRepairReasonObject?.[0]?.hazardType || "";
      let hazardName: string;
      try {
        hazardName = (await api.getHazardNameByType(hazardType)) ?? hazardType;
      } catch (e) {
        console.error(e);
        props.history.push("/GenericError");
        return false;
      }
      const triageType = hazardName.toLowerCase().includes("triage")
        ? hazardName
        : `${hazardName} Triage Hazard`;

noteLines.push(
  `Outcome: ${isHHSRSAssessmentCompleted ? triageType : "Standard Repair"}`
);
      await api.postNoteForWorkorder(serialNumber, sequenceNumber, {
        noteTypeId: NoteType.Other,
        text: noteLines.join("\n"),

      });
      return true;
    } catch (e) {
      console.warn(`Failed to post HHSRS pre-assessment note for ${serialNumber}/${sequenceNumber}`, e);
      return true;
    }
  };

  const getIsPotentialDuplicate = () => {
    return userChosenDuplicateQuestionFromStore === "I don't think this is a duplicate" && !duplicateOverridePermissions;
  }

  const getIsVulnerable = () => {
    return userChosenVulnerabilityQuestionFromStore === "Yes";
  }

  const useLocationID = () => {
    const locationIDMapping: { [key: string]: string } = {
      '3': 'Bathroom',
      '4': 'Bedroom',
      '9': 'Kitchen',
      '15': 'Multiple Rooms',
      '31': 'Other room in your home',
    };

    const reverseMapping = Object.fromEntries(
      Object.entries(locationIDMapping).map(([key, value]) => [value, key])
    );
    return reverseMapping[userChoosenDmcLocation] || null;
  };

  let locationID = useLocationID();

  const displayDMCCheck = () => {
    if (
      !isDmcEnabledFlag ||
      !DMCChecksavedAnswervalue ||
      DMCChecksavedAnswervalue.trim() === "" ||
      (hasSORToSkipCausingDMQues || !isUndefinedNullOrEmpty(workOrderObject?.associatedWorkOrdersIdentifier) || hasExistingDMCaseOrWO)
    ) {
      return null;
    }
    return (
      <TableRow
        className="flex items-center bg-white">
        <TableCell role="presentation"
          className="w-2/3 p-3 firstcol">
          <div role="presentation"
            className="text-base padding-new color_black global-txt">
            {t("DMC_Question")}
          </div>
        </TableCell>
        <TableCell role="presentation" className="w-2/3 p-0 secondcol">
          <div role="presentation" className="text-base padding-new color_black global-txt">
            {DMCChecksavedAnswervalue}
          </div>
        </TableCell>
        <TableCell role="presentation"
          className="w-2/3 p-3 thirdcol paddright">
          <div role="presentation" className="edt-spc padding-new text-right pr-8">
            {!IsRecall && (
              <i
                data-testid="dmc-question-edit-icon"
                className="fas fa-edit text-teal text-lg cursor-pointer"
                title={t("confirmation_edit")}
                onClick={() => {
                  props.history.push(`/ConfirmedDampMould`);
                }}
                onKeyDown={() => {
                  props.history.push(`/ConfirmedDampMould`);
                }}
              ></i>
            )}
          </div>
        </TableCell>
      </TableRow>
    );

  }

  const renderDMCQuestionAnswers = () => {
    if (!showDMQuestionnaireResponses() ||
      isUndefinedNullOrEmpty(dmcQuestionsFromReducer?.additionalInfo)
    ) {
      //Hiding questions IF:
      // DM questionnaire is disabled OR
      // DM Questionnaire NOT answered OR
      // Resuming draft/triage repair when DM Questionnaire answered, a supplimentary DM Investigation feature is enabled but DM Investigation created previously against repair and/or theres an existing DM Case/Repair on asset
      return null;
    }
    // updated logic to display question label from dmcQuestionsFromReducer and all selected answers from dmcAnswersFromReducer
    return dmcQuestionsFromReducer?.additionalInfo?.map((question: any, index: number) => {
      let matchAns: any;
      if (question?.type === "List") {
        const matchingAnswer = dmcAnswersFromReducer[question?.questionId];
        matchAns = question?.options?.find((option: any) => option?.id === matchingAnswer[0])?.value;
      } else if (question?.type === "Multiple") {
        const matchingAnswers = Object.keys(dmcAnswersFromReducer).filter(
          (answerKey: string) => answerKey === question?.questionId
        );

        if (matchingAnswers.length > 0) {
          matchAns = question?.options
            ?.filter((option: any) =>
              matchingAnswers.some((answerKey: string) =>
                dmcAnswersFromReducer[answerKey]?.includes(option?.id)
              )
            )
            .map((option: any) => option?.value)
            .join(", ");
        }
      }

      // Rendering all the question lable and answer value along with edit functionality 
      return (
        <TableRow key={index} className="flex items-center bg-white">
          <TableCell role="presentation" className="w-2/3 p-3 firstcol">
            <div role="presentation" className="text-base padding-new color_black global-txt">
              {question?.label || "-"}
            </div>
          </TableCell>
          <TableCell role="presentation" className="w-2/3 p-0 secondcol">
            <div role="presentation" className="text-base padding-new color_black global-txt">
              {matchAns}
            </div>
          </TableCell>
          <TableCell role="presentation" className="w-2/3 p-3 thirdcol paddright">
            <div role="presentation" className="edt-spc padding-new text-right pr-8">
              {!IsRecall && (
                <i
                  data-testid="dmc-question-edit-icon"
                  className="fas fa-edit text-teal text-lg cursor-pointer"
                  title={t("confirmation_edit")}
                  onClick={() => {
                    props.history.push(`/DampAndMouldAssesment/${question?.pageGroupId}`);
                  }}
                  onKeyDown={() => {
                    props.history.push(`/DampAndMouldAssesment/${question?.pageGroupId}`);
                  }}
                ></i>
              )}
            </div>
          </TableCell>
        </TableRow>
      );
    });
  }

  const exitButtonHandler = () => {
    dispatch(dmcCheckSavedAnswer(""))
    dispatch(userChosenPropertyId(""));
    dispatch(userChosenPropertyType(""));
    dispatch(userChosenPropertyAddress(""));
    dispatch(userChosenRepairLocationId(0));
    dispatch(userChosenRepairLocation(""));
    dispatch(userChosenHighLevelDescription(""));
    dispatch(userChosenSupplementaryQuestions(""));
    dispatch(userChosenAdditionalDescription(""));
    dispatch(userChosenVandalismQuestion("No"));
    dispatch(userChosenVandalismAdditionalInformation(""));
    dispatch(userChosenCovidQuestion(""));
    dispatch(userChosenNotifyAll(null));
    dispatch(userChosenContactDetails(""));
    dispatch(userChosenSTATUS(""));
    dispatch(userChosenEligibilityErrorCode(""));
    dispatch(userChosenContactPhone(""));
    dispatch(userChosenContactName(""));
    dispatch(userChosenRelationDetails(""));
    dispatch(workOrderRepairObject(null));
    dispatch(backToRepairAsset(false))
    dispatch(userChosenResumeRepair(false));
    dispatch(loadDuplicateRepairPage(false));
    dispatch(getContractorName(null));
    if (IsRecall) {
      dispatch(workOrderData(originalWorkOrderObject))
      props.history.push("/WorkOrder360View");
    }
    else {
      dispatch(workOrderRepairObject(null));
      dispatch(originalWorkOrderData(null))
      props.history.push("/LandingView");
    }
  };

  const saveDraftAndExit = () => {
    dispatch(userChosenSaveExit(true))
    dispatch(originalWorkOrderData(null))
    dispatch(backToRepairAsset(false))
    const worksOrder = new WorksOrderRequest(workOrderObject);
    dispatch(workOrderData(worksOrder))
    props.history.push(`/WorkOrder360View/${worksOrder.identifiers?.worksOrderIdentifier}`);
    setTimeout(() => {
      dispatch(userChosenSaveExit(false))
    }, 6000);
  };

  const backButtonHandler = () => {
    if (emailRedirect) {
      props.history.push("/LandingView");
      return;
    }
    if (assetDetails?.assetType !== AssetType.Property) {
      dispatch(userChosenNotifyAll(workOrderObject?.notifyAll));
      props.history.push("/BlockCommunication");
      props.history.action = "POP";
      return;
    }
    else {
      props.history.push("/CustomerDetails");
      props.history.action = "POP";
    }

  };

  const checkIfEligibileForAppointing = (workOrderObj: any, contractor: any) => {
    const isHHSRSEmergency =
      isHHSRSAssessmentCompleted &&
      workOrderObj?.priority === RepairPriorityCode.AWAABSLAWEMERGENCY;

    return isUndefinedNullOrEmpty(workOrderObj?.jobNo) ||
      workOrderObj?.isEmergency ||
      isHHSRSEmergency ||
      !!workOrderObj?.isRecall ||
      !contractor?.statuses?.isIntegrated ||
      contractor?.statuses?.isBuilder;
  }

  const setupBundleForAppointing = (originalWorkOrder: any, dmcWorkOrder: any) => {
    const skipAppointmentSchedulerOriginal = checkIfEligibileForAppointing(originalWorkOrder, contractorDeterminationResponse);
    const skipAppointmentSchedulerDMC = checkIfEligibileForAppointing(dmcWorkOrder, dMCWOContractorResponse?.[0]);

    if (skipAppointmentSchedulerOriginal && skipAppointmentSchedulerDMC) {
      props.history.push("/RepairFinalDetails");
    } else {

      const appointmentBundle = Helper.buildAppointmentBundle({
        original: {
          id: originalWorkOrder?.id,
          contractorCode: originalWorkOrder?.contractor || "",
          contractorName: originalWorkOrder?.contractorName,
          jobNo: (originalWorkOrder?.jobNo || "").trim(),
          operationKey: undefined,
          isAppointable: !skipAppointmentSchedulerOriginal,
          calendar: null
        },
        dmc: !isUndefinedNullOrEmpty(dmcWorkOrder) ? {
          id: dmcWorkOrder?.id,
          contractorCode: dmcWorkOrder?.contractor || "",
          contractorName: dmcWorkOrder?.contractorName,
          jobNo: (dmcWorkOrder?.jobNo || "").trim(),
          operationKey: undefined,
          isAppointable: !skipAppointmentSchedulerDMC,
          calendar: null
        } : null
      });

      dispatch(saveAppointmentBundle(appointmentBundle));
      props.history.push("/AppointmentScheduler");
    }
  }



  const callPageHandler = async () => {
    try {
      let dmcWorkOrderWithFinalPatch = null, originalWorkOrderWithFinalPatch = null;
      setdisabled(true);
      setIsLoading(false);
      setIsLoadingWOcreation(true);
      if (!isUndefinedNullOrEmpty(dMCWOContractorResponse)) {
        dmcWorkOrderWithFinalPatch = await dmcAggregator();
      }

      originalWorkOrderWithFinalPatch = await patchOriginalWorkOrder(dmcWorkOrderWithFinalPatch);

      const [originalWOSerialNumber, originalWOSequenceNumber] = (originalWorkOrderWithFinalPatch?.jobNo ?? workOrderObject?.jobNo ?? "")
        .split("/", 2)
        .map((value: string) => value.trim());
      if (originalWOSerialNumber && originalWOSequenceNumber) {
        addNotesToDMCausingRepair(originalWOSerialNumber, originalWOSequenceNumber);
        const canContinue = await addPreAssessmentNote(originalWOSerialNumber, originalWOSequenceNumber);
        if (!canContinue) {
          return;
        }
      }

      setupBundleForAppointing(originalWorkOrderWithFinalPatch, dmcWorkOrderWithFinalPatch);
    }
    catch (e) {
      console.error(e);
      props.history.push("/genericerror"); //ChangeLater: Repair final details if any error after confimraiotn button click
    }
    finally {
      setdisabled(false);
      setIsLoading(false);
      setIsLoadingWOcreation(false);
    }
  };

  const redirect = (url: string) => {
    workOrderObject.isOutOfHours = false;
    dispatch(workOrderRepairObject(workOrderObject));
    dispatch(isEditState(true));
    props.history.replace(url);
  };


  const isHhsrsOption = () => {
    if (hhsrsOption === true) {
      return "Yes";
    } else {
      return "No";
    }
  };

  
  
  const renderData = (item: any, index: any) => {
    return (
      <>
        <TableRow
          id={"confirmation-tr1" + item[0]}
          className="flex items-center bg-white"
        >
          <TableCell role="presentation"
            id={"confirmation-tr1-td1" + item[0]}
            className="w-2/3 p-3 firstcol"
          >
            <div role="presentation"
              id={"confirmation-tr1-div1" + item[0]}
              className="text-base padding-new color_black global-txt"
            >
              {/* @ts-ignore */}
              {questions?.translation[item[0]] === t("Customer_Details")
                ? t("Customer_Details_Text_Two")
                : //  @ts-ignore
                questions?.translation[item[0]]}
            </div>
          </TableCell>
          <TableCell role="presentation"
            id={"confirmation-tr1-td2" + item[0]}
            data-testid={"confirmation-tr1-div2" + item[0]}
            className="w-2/3 p-0 secondcol"
          >
            <div role="presentation"
              id={"confirmation-tr1-div2" + item[0]}
              className="text-base padding-new color_black global-txt"
            >
              {item[0] === "HHRS" && (isHhsrsOption())}
              {item[0] === "hhsrs_Type" && (hhsrsCategory)}
              {item[0] === "hhsrs_score" && (hhsrsSeverity)}
              {item[0] === "VandalismQuestion" ? (
                getVandalismDisplayText()
              ) : (
                <>
                  {" "}

                  {
                    !savedResponses[item[1]?.reduxKeyQs]
                      ? item[1]?.reduxKey === "userChosenPropertyType"
                        ? (assetDetails?.assetType || "")
                        : (
                          typeof savedResponses[item[1]?.reduxKey] === "string"
                            ? savedResponses[item[1]?.reduxKey].split("@")[0]
                            : typeof savedResponses[item[1]?.reduxKey] === "number"
                              ? savedResponses[item[1]?.reduxKey].toString()
                              : ""
                        )
                      : ""
                  }
                  {savedResponses[item[1]?.reduxKeyQs]
                    ?
                    savedResponses[item[1]?.reduxKeys]
                    : ""
                  }
                  {"\n"}
                  {savedResponses[item[1]?.reduxKeyQs]}
                  <br></br>
                  {savedResponses[item[1]?.reduxKeyselect]}
                </>)}
            </div>
          </TableCell>

          <TableCell role="presentation"
            id={"confirmation-tr1-td3" + item[0]}
            className="w-2/3 p-3 thirdcol paddright"
          >
            <div role="presentation"
              id={"confirmation-tr1-div3" + item[0]}
              className="edt-spc padding-new text-right pr-8"
            >
              {" "}
              {!IsRecall && (
                <i
                  data-testid="confirmation-icon"
                  id={"confirmation-tr1-icon" + item[0]}
                  className="fas fa-edit text-teal text-lg cursor-pointer"
                  title={t("confirmation_edit")}
                  onClick={() => {
                    if (
                      isEnhancedDiagnosticsRepair &&
                      (
                        ["repair_property_label", "repair_report_label", "confirmation_diagnostics_block_title"].includes(item[0])
                      )
                    ) {
                      setEditUrl(`/${item[1]?.urlPath}`);
                      setIsEditModalOpen(true);
                    } else {
                      redirect((item[1].reduxKey === "userChosenEmergencyQuestion" && isEnhancedDiagnosticsRepair) ? "/RepairEDEmergency" : `/${item[1]?.urlPath}`);
                    }
                  }}
                ></i>
              )}
            </div>
          </TableCell>
        </TableRow>
      </>
    );
  };

  const patchOriginalWorkOrder = async (dmcWorkOrderWithFinalPatch: any) => {
    let isMultiDMWorkOrder = !isUndefinedNullOrEmpty(dMCWOContractorResponse),
      workOrderIdDMC = dmcWorkOrderWithFinalPatch?.id,
      jobNoDMC = dmcWorkOrderWithFinalPatch?.jobNo
    try {
      const contractorDetail = determinedcontractordetails?.[0];
      const isEMA = contractorDetail?.statuses?.isEMA;

      let isUnknownEMA = false;

      if (
        contractorDetail?.contractorSites?.some(
          (site: string) =>
            site === EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE ||
            site === EMAContractorType.UNKNOWN_EMA_TRIAGE
        )
      ) {
        isUnknownEMA = true;
      }


      workOrderObject.isDraft = false;
      // For Unknown EMA, keep work order as draft; otherwise mark as submitted
      if (isEMA) {
        workOrderObject.isEMA = true;
        //Commented line as per discussion need to review
        //workOrderObject.isDraft = isUnknownEMA;
      }

      const determinedContractor = contractorDetail?.contractorSites
        ? contractorDetail.contractorSites[0]
        : null;
      //for recall repairs determinedContractor is null because no contractor determination call happens
      // workOrderObject.contractor has values assigned from workorder 360 view
      if (!isUndefinedNullOrEmpty(determinedContractor) ) {
        workOrderObject.contractor = determinedContractor;
      }

      userChosenSupplementaryQuestionsVal === "Yes"
        ? (workOrderObject.isSupplementary = true)
        : userChosenSupplementaryQuestionsVal === "No"
          ? (workOrderObject.isSupplementary = false)
          : (workOrderObject.isSupplementary = null);

      userChosenVandalismQuestionVal === "Yes" && assetDetails?.statuses?.isInDefects === true && vandalismConfigValue === true
        ? (workOrderObject.isVandalism = true)
        : userChosenVandalismQuestionVal === "No" && assetDetails?.statuses?.isInDefects === true && vandalismConfigValue === true
          ? (workOrderObject.isVandalism = false)
          : (workOrderObject.isVandalism = null);

      userChosenCovidQuestionVal === "Yes" && covidConfigValue
        ? (workOrderObject.isCovidSelfIsolated = true)
        : userChosenCovidQuestionVal === "No" && covidConfigValue
          ? (workOrderObject.isCovidSelfIsolated = false)
          : (workOrderObject.isCovidSelfIsolated = null);

      userChosenDuplicateQuestionFromStore === "" && workOrderObject.isPotentialDuplicate !== true
        ? (workOrderObject.isPotentialDuplicate = false)
        : (workOrderObject.isPotentialDuplicate = !duplicateOverridePermissions);
      (userChosenVulnerabilityQuestionFromStore !== "" &&
        userChosenVulnerabilityQuestionFromStore !== null &&
        userChosenVulnerabilityQuestionFromStore === "Yes") || workOrderObject.isVulnerable === true
        ? (workOrderObject.isVulnerable = !hideVulnerablePagePermission)
        : userChosenVulnerabilityQuestionFromStore === "No"
          ? (workOrderObject.isVulnerable = false)
          : (workOrderObject.isVulnerable = null);
      userChosenVulnerabilityAdditionalInformation !== "" && !hideVulnerablePagePermission
        ? (workOrderObject.VulnerableResponseText =
          userChosenVulnerabilityAdditionalInformation)
        : (workOrderObject.VulnerableResponseText = null);


      if (userChosenSOR !== "") {
        workOrderObject.sorCode = userChosenSOR;
      } else {
        workOrderObject.sorCode = "NA"
      }

      if (isHHSRSAssessmentCompleted && !IsRecall) {
        workOrderObject.crimeReferenceNumber = "";
        workOrderObject.repairCauseId = Helper.HHSRSRepairCauseId;
        workOrderObject.repairCause =
          Helper.RepairCauseLabels[Helper.HHSRSRepairCauseId];
      } else if (userVandalismChoice === "Yes" && assetDetails?.statuses?.isInDefects === true && vandalismConfigValue === true) {
        workOrderObject.crimeReferenceNumber =
          userChosenVandalismAdditionalInformationBackButton;
        workOrderObject.repairCause = "Vandalism or Damage";
        workOrderObject.repairCauseId =
          RepairCauseId[
          workOrderObject.repairCause as keyof typeof RepairCauseId
          ];
      }
      else {
        workOrderObject.crimeReferenceNumber = "";
        workOrderObject.repairCause = "General Wear and Tear";
        workOrderObject.repairCauseId =
          RepairCauseId[
          workOrderObject.repairCause as keyof typeof RepairCauseId
          ];
      }
      const _worksOrderRequest = new WorksOrderRequest(workOrderObject);
      const woRequestParameters =
        _worksOrderRequest.updateWorkOrderParameter(workOrderObject);
      woRequestParameters.originalWorkOrderIdentifier = workOrderObject?.originalWorkOrderIdentifier
      woRequestParameters.isSubmitted = true;
      if (isMultiDMWorkOrder && workOrderIdDMC) {
        woRequestParameters.associatedWorkOrdersIdentifier = workOrderIdDMC;
        woRequestParameters.associatedWorkOrdersJobNumber = jobNoDMC;
        woRequestParameters.associatedWorkOrdersType = "DampAndMould";
      }
      if (IsRecall) {
        dispatch(saveHHSRSAssessmentCompleted(false));
        woRequestParameters.hhsrsAssessment = undefined;
      }

      await api.updateWorkOrderRepair(
        woRequestParameters,
        workOrderObject?.id,
        "eTag"
      );

      //set assosciated information to main WO      
      workOrderObject.associatedWorkOrdersIdentifier = workOrderIdDMC;
      workOrderObject.associatedWorkOrdersJobNumber = jobNoDMC;
      workOrderObject.associatedWorkOrdersType = "DampAndMould";




      if (
        !isTriageRepair &&
        (
          !isCatalystDefectTriageCase ||
          (
            dmcInspectionSorCodes?.includes(userChosenSOR) &&
            isCatalystDefectTriageCase &&
            workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.High
          )
        ) &&
        !isCatalystTriageTier2OrEma &&
        !isUnknownEMA) {

        //get job number
        const handle = pollJobNumber({
          workOrderId: workOrderObject?.id,
          timeoutMs: WOCreationTimeoutSeconds * 1000,
          delayMs: WOCreationPollingDelaySeconds * 1000,
          immediateFirstAttempt: true,
        });

        try { pollAbortRef.current?.(); } catch { }
        pollAbortRef.current = handle.abort;

        const { repair, attempts } = await handle.promise;

        pollAbortRef.current = null;

        console.log(`Job number fetch attempts: ${attempts} for workOrderId ${workOrderObject?.id}`);

        if (!repair || typeof repair !== "object") {
          dispatch(
            woFailureCase(
              Helper.WOFailureMethod.RepairGetJobNumber,
              t("Repair_Failed_JobNumber_Msg")
            )
          );
          console.warn(
            `Repair object not available after ${attempts} attempts for workOrderId ${workOrderObject?.id}, note not added`
          );
        } else {
          const jobNo = (repair?.jobNo || "").trim();
          if (!jobNo) {
            dispatch(
              woFailureCase(
                Helper.WOFailureMethod.RepairGetJobNumber,
                t("Repair_Failed_JobNumber_Msg")
              )
            );
            console.warn(
              `Job number not found after ${attempts} attempts for workOrderId ${workOrderObject?.id}, note not added`
            );
          } else {
            const [serialNumber, sequenceNumber] = jobNo.split("/", 2).map((s: string) => s.trim());
            if (!serialNumber || !sequenceNumber) {
              console.warn(
                `Invalid job number format "${jobNo}" for workOrderId ${workOrderObject?.id}, note not added`
              );
            } else {
              workOrderObject.jobNo = jobNo;
              if (repair?.premisesType) {
                workOrderObject.premisesType = repair.premisesType;
                dispatch(userChosenPropertyType(repair.premisesType));
              }
              if (repair?.caseIdentifier) {
                workOrderObject.caseIdentifier = repair.caseIdentifier;
                dispatch({ type: CASE_IDENTIFIER, payload: repair.caseIdentifier });
              }
              if (repair?.contractorName) workOrderObject.contractorName = repair.contractorName;
            }
          }
        }
      }

      dispatch(workOrderRepairObject(workOrderObject));
    } catch (e) {
      dispatch(
        woFailureCase(
          Helper.WOFailureMethod.RepairUpdateWorkOrder,
          t("Repair_Update_WorkOrder_Msg")
        )
      );
    }
    return workOrderObject;
  };

  const getContactorAndRepairPriority = async (
    payload: {
      repairId: string;
      priorityCode: string;
      region: string;
      sorCode: string;
      repairType: string;
      repairTime: string;
      uprn: string;
      raisedDate: string;
      repairCauseId: number;
      maintenanceResponsibility: string;
      repairResponsibility: string;
      borough: string;
      isVandalism: boolean;
      isEmergency: boolean;
      description: string;
      isVulnerable: boolean;
      tenureCode: any;
      isRecall?: boolean;
      isAnaType?: boolean;
      isV14Upgradable?: boolean;
      workProgramme?: string;
      premisesType?: string;
      assessmentInformation: {
        outcome: {
          riskRating: string;
          adjustedRiskRating: string;
        },
        type: string
      };
    },
    isCatalystDefectTriageCase: boolean,
    scope: "repair" | "dmc"
  ) => {
    try {
      let contractorDetail: any = null;
      let assessmentTypeValue = '';
      let adjustedRiskRatingValue = '';
      let riskRatingValue = payload.assessmentInformation?.outcome?.riskRating;
      if (dmcInspectionSorCodes.includes(payload.sorCode)) {
        assessmentTypeValue = payload.assessmentInformation?.type;
        adjustedRiskRatingValue = payload.assessmentInformation?.outcome?.adjustedRiskRating;
        riskRatingValue = adjustedRiskRatingValue;
      }

      const isHHSRSRepair = scope === "repair" && isHHSRSAssessmentCompleted;
      const contractorAssessmentType = isHHSRSRepair
        ? workOrderObject?.hhsrsAssessment?.category ?? assessmentTypeValue
        : assessmentTypeValue;
      const contractorRiskRating = isHHSRSRepair
        ? workOrderObject?.hhsrsAssessment?.severity ?? adjustedRiskRatingValue
        : adjustedRiskRatingValue;
      if (isCatalystDefectTriageCase) {
        contractorDetail = [
          {
            id: catalystTriageContractorType.CATALYST_TRIAGE_DEFECT,
            name: "Catalyst Defect Triage",
            statuses: {
              isIntegrated: false,
              isBuilder: false,
              isSubContractor: false,
              isEMA: false,
              isActive: true,
            },
            contractorSites: ["CATALYST_TRIAGE_DEFECT"],
            emaType: "",
            contacts: [{}],
            _links: [],
            parentIdentifier: null,
          },
        ];
      } else {
        try {
          const options:DeterminedContractorOptions = {
            identifier: payload.repairId,
            priority: payload.priorityCode,
            region: payload.region,
            borough: payload.borough,
            repairType: payload.repairType,
            repairTime: payload.repairTime,
            uprn: payload.uprn,
            raisedDate: payload.raisedDate,
            repairCauseId: payload.repairCauseId,
            maintenanceResponsibility: payload.maintenanceResponsibility,
            repairResponsibility: payload.repairResponsibility,
            isVandalism: payload.isVandalism,
            assessmentType: contractorAssessmentType,
            riskRating: contractorRiskRating,
            skipResponsibilityCheckForEMA: skipRespCheckForEMA
          }
          contractorDetail = await api.getDeterminedContractor(options);
        } catch (e) {
          dispatch(
            woFailureCase(
              scope === "dmc" ? Helper.WOFailureMethod.DmcDetermineContractor : Helper.WOFailureMethod.RepairDetermineContractor,
              scope === "dmc" ? t("DMC_Failed_Contractor_Msg") : t("Repair_Failed_Contractor_Msg")
            )
          );
          throw e;
        }

        if (!Array.isArray(contractorDetail) || contractorDetail.length === 0 || !contractorDetail[0]?.id) {
          const e = new Error("No contractor details returned");
          dispatch(
            woFailureCase(
              scope === "dmc" ? Helper.WOFailureMethod.DmcDetermineContractor : Helper.WOFailureMethod.RepairDetermineContractor,
              scope === "dmc" ? t("DMC_Failed_Contractor_Msg") : t("Repair_Failed_Contractor_Msg")
            )
          );
          throw e;
        }
      }
      const emaStatus = contractorDetail[0]?.statuses?.isEMA === true;
      const hasNoPhone =
        !contractorDetail[0]?.contacts?.[0]?.addresses?.digitalAddresses?.[0]?.telecomsAddresses?.[0]?.number;
      const hasNoEmail =
        !contractorDetail[0]?.contacts?.[0]?.addresses?.digitalAddresses?.[0]?.emailAddresses;

      if (
        emaStatus &&
        hasNoPhone &&
        hasNoEmail
      ) {
        contractorDetail = [
          {
            id: EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE,
            name: "EMA Unknown Contact Details Triage",
            statuses: {
              isIntegrated: false,
              isBuilder: false,
              isSubContractor: false,
              isEMA: true,
              isActive: true,
            },
            contractorSites: ["EMA_UNKNOWN_CONTACTDETAILS_TRIAGE"],
            emaType: "",
            contacts: [{}],
            _links: [],
            parentIdentifier: null,
          },
        ];
      }

      // Fetch repair priority
        const priorityAssessmentType =
         payload.assessmentInformation?.type;
     
      const priorityRiskRating = isHHSRSRepair
        ? workOrderObject?.hhsrsAssessment?.severity ?? hazardAssessmentOutcome?.risk?.adjusted ?? riskRatingValue
        : riskRatingValue;
      let repairPriority: any;
      try {
        repairPriority = await api.repairPriorityDetermination({
          repairType: payload.sorCode,
          contractorIdentifier: contractorDetail[0].id,
          isEmergency: payload.isEmergency,
          isRecall: payload.isRecall ?? false,
          isEMA: contractorDetail[0].statuses.isEMA ? "Y" : "N",
          isVulnerable: payload.isVulnerable,
          description: payload.description,
          raisedDate: payload.raisedDate,
          channel: RepairChannel.ColleagueSelfServe,
          riskRating: priorityRiskRating,
          assessmentType: priorityAssessmentType,
          isAnaType: payload.isAnaType,
          isV14Upgradable: payload.isV14Upgradable,
          workProgramme: payload.workProgramme,
          premisesType: payload.premisesType,
          tenureCode: customerDetails?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode ?? "",
          hasSeasonalPriority:selectedRepairReasonObject?.[0]?.hasSeasonalPriority ?? false
        });
      } catch (e) {
        dispatch(
          woFailureCase(
            scope === "dmc" ? Helper.WOFailureMethod.DmcDeterminePriority : Helper.WOFailureMethod.RepairDeterminePriority,
            scope === "dmc" ? t("DMC_Failed_Priority_Msg") : t("Repair_Failed_Priority_Msg")
          )
        );
        throw e;
      }

      if (!repairPriority) {
        const e = new Error("Empty priority determination response");
        dispatch(
          woFailureCase(
            scope === "dmc" ? Helper.WOFailureMethod.DmcDeterminePriority : Helper.WOFailureMethod.RepairDeterminePriority,
            scope === "dmc" ? t("DMC_Failed_Priority_Msg") : t("Repair_Failed_Priority_Msg")
          )
        );
        throw e;
      }

      return {
        determinedContractorResp: contractorDetail,
        updatedRepairPriorityResp: repairPriority,
      };
    } catch (error) {
      console.error("Error in getContactorAndRepairPriority:", error);
      throw error;
    }
  };

  const getRecallContractorAndPriority = async (workOrderObject: any, originalWoPayload: any, customerDetails: any) => {
    let determinedContractor = null;
    let commonPriorityResponse = null;
    let getContractorsByConsiteResponse = await api.getContractors(workOrderObject?.contractor);
    if (getContractorsByConsiteResponse?.length) {
      determinedContractor = getContractorsByConsiteResponse;
      determinedContractor[0].contractorSites = determinedContractor?.[0]?.contractorSites?.filter(
        (conSite) => conSite === workOrderObject?.contractor
      );
      commonPriorityResponse = await api.repairPriorityDetermination({
        repairType: originalWoPayload.sorCode,
        contractorIdentifier: determinedContractor[0].id,
        isEmergency: originalWoPayload.isEmergency,
        isRecall: originalWoPayload.isRecall ?? false,
        isEMA: determinedContractor[0].statuses.isEMA ? "Y" : "N",
        isVulnerable: originalWoPayload.isVulnerable,
        description: originalWoPayload.description,
        raisedDate: originalWoPayload.raisedDate,
        channel: RepairChannel.ColleagueSelfServe,
        riskRating: originalWoPayload.assessmentInformation?.outcome?.adjustedRiskRating,
        assessmentType: originalWoPayload.assessmentInformation?.type,
        isAnaType: originalWoPayload.isAnaType,
        isV14Upgradable: originalWoPayload.isV14Upgradable,
        workProgramme: originalWoPayload.workProgramme,
        premisesType: originalWoPayload.premisesType,
        tenureCode: customerDetails?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode ?? "",
        hasSeasonalPriority:selectedRepairReasonObject?.[0]?.hasSeasonalPriority ?? false

      });
      return { determinedContractor, commonPriorityResponse };
    } else {
      console.log("Cannot retrieve old contract");
      return { determinedContractor: null, commonPriorityResponse: null };
    }
  }

  const getVandalismDisplayText = (): string => {
    if (userChosenVandalismQuestionVal === "Yes") {
      if (userChosenVandalismAdditionalInformationBackButton?.trim()) {
        return `Yes , ${userChosenVandalismAdditionalInformationBackButton}`;
      } else {
        return "Yes";
      }
    } else if (userChosenVandalismQuestionVal === "No") {
      return "No";
    }
    return "";
  };

  const isHHRSOnlyPreferenceMode = (): boolean => {
    return enableHHRSPreference && !showDMQuestionnaireResponses();
  };

  const getIsEmergencyOverride = (
    priorityCodeValue: string | undefined,
    priorityIsEmergency: boolean
  ): boolean => {
    if (priorityCodeValue === RepairPriorityCode.AWAABSLAWEMERGENCY) {
      return true;
    }

    if (
      priorityCodeValue === RepairPriorityCode.AWAABSLAWLOW ||
      priorityCodeValue === RepairPriorityCode.AWAABSLAWSIGNIFICANT
    ) {
      return false;
    }

    return priorityIsEmergency;
  };

  
const getHHRSPreferenceHeaderRow = (effectivePriority: any, t: any) => {
  switch (effectivePriority) {
    case RepairPriorityCode.AWAABSLAWLOW:
    case RepairPriorityCode.AWAABSLAWEMERGENCY:
    case RepairPriorityCode.AWAABSLAWSIGNIFICANT:
      return t("CPR088_HHRSPreferenceTextFinalPage");
    default:
      return "";
  }
};

  const getDMCEmailReportLabel = (): string => {
    if (isHHRSOnlyPreferenceMode()) {
      return getHHRSPreferenceHeaderRow(priorityCodeValue,t);
    }
    if (workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.Low) {
      return t("DML_text_confirmationDetails_page");
    }
    return t("DMC_text_contact_page");
  };

  const getDMCEmailReportValueText = (): string => {
    if (isHHRSOnlyPreferenceMode()) {
      return getDMReportPreferenceValue || "";
    }
    if (getDMReportPreferenceValue === t("DMC_Correspondence_Adress")) {
      return getDMReportPreferenceValue;
    }
    return t("DMC_option_email") + (getDMReportPreferenceValue || "");
  };

  const displayContractorName = () => {

    return (
      <TableRow
        className="flex items-center bg-white">
        <TableCell role="presentation"
          className="w-2/3 p-3 firstcol">
          <div role="presentation"
            className="text-base padding-new color_black global-txt">
            {t("Add_contractor")}
          </div>
        </TableCell>
        <TableCell role="presentation" className="w-2/3 p-0 secondcol">
          <div role="presentation" className="text-base padding-new color_black global-txt">
            {isUnknownEmaTriage
              ? "Managing Agent"
              : contractorname || "-"}
          </div>
        </TableCell>
        <TableCell role="presentation"
          className="w-2/3 p-3 thirdcol paddright">
          <div role="presentation"
            className="edt-spc padding-new text-right pr-8">
            {""}</div>
        </TableCell>
      </TableRow>
    );

  };

  const displayDMCContractorName = () => {
    if (!isAdditionalDMWorkOrderRequired || !isEligibleForDMInspectionMultiWO() || contractorDeterminationResponse?.id === catalystTriageContractorType.CATALYST_TRIAGE_TIER2) {
      return null; // Hide if in-eligible for additional DM Inspection of Multi DM WO feature turned off
    }
    return (
      <TableRow
        className="flex items-center bg-white">
        <TableCell role="presentation"
          className="w-2/3 p-3 firstcol">
          <div role="presentation"
            className="text-base padding-new color_black global-txt">
            {t("CPR080")}
          </div>
        </TableCell>
        <TableCell role="presentation" className="w-2/3 p-0 secondcol">
          <div role="presentation" className="text-base padding-new color_black global-txt">
            {dMCWOContractorResponse?.[0].name || "-"}
          </div>
        </TableCell>
        <TableCell role="presentation"
          className="w-2/3 p-3 thirdcol paddright">
          <div role="presentation"
            className="edt-spc padding-new text-right pr-8">
            {""}</div>
        </TableCell>
      </TableRow>
    );

  };

  const displayDMCEmailReport = () => {
    const isHHRSPreferenceRow = isHHRSOnlyPreferenceMode();
    const isDMCPreferenceRow = showDMQuestionnaireResponses();
    const preferenceLabel = getDMCEmailReportLabel();

    // Show preference row only for DMC or HHRS-only flows.
    if (!isHHRSPreferenceRow && !isDMCPreferenceRow) {
      return null;
    }

    // Keep DMC behavior unchanged: hide when no preference value is saved.
    if (isDMCPreferenceRow && !isHHRSPreferenceRow && isUndefinedNullOrEmpty(getDMReportPreferenceValue)) {
      return null;
    }

    // HHSRS report preference is applicable only when the priority has a configured question.
    if (isHHRSPreferenceRow && isUndefinedNullOrEmpty(preferenceLabel)) {
      return null;
    }
      
    return (
      <TableRow
        className="flex items-center bg-white">
        <TableCell role="presentation"
          className="w-2/3 p-3 firstcol">
          <div role="presentation"
            className="text-base padding-new color_black global-txt">
            {preferenceLabel}
          </div>
        </TableCell>
        <TableCell role="presentation" className="w-2/3 p-0 secondcol">
          <div role="presentation" className="text-base padding-new color_black global-txt">
            {getDMCEmailReportValueText()}
          </div>
        </TableCell>
        <TableCell role="presentation"
          className="w-2/3 p-3 thirdcol paddright">
          <div role="presentation"
            className="edt-spc padding-new text-right pr-8">
            <i
              data-testid="dmc-question-edit-icon"
              className="fas fa-edit text-teal text-lg cursor-pointer"
              title="Edit"
              onClick={() => {
                props.history.push(`/CustomerDetails`);
              }}
              onKeyDown={() => {
                props.history.push(`/CustomerDetails`);
              }}
            ></i></div>
        </TableCell>
      </TableRow>
    );

  };

  const displayEMAContactDetails = () => {
    if (isContractorLoading) return null;
    const isEma =
      contractorDeterminationResponse?.statuses?.isEMA === true;

    const isUnknownEma =
      contractorDeterminationResponse?.id === EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE ||
      contractorDeterminationResponse?.id === EMAContractorType.UNKNOWN_EMA_TRIAGE ||
      contractorDeterminationResponse?.contractorSites?.some(
        (site: string) =>
          site === EMAContractorType.EMA_UNKNOWN_CONTACTDETAILS_TRIAGE ||
          site === EMAContractorType.UNKNOWN_EMA_TRIAGE
      );

    if (!isEma) {
      return null;
    }

    const telecoms =
      contractorDeterminationResponse?.contacts?.[0]?.addresses?.digitalAddresses?.[0]?.telecomsAddresses || [];

    const emails =
      contractorDeterminationResponse?.contacts?.[0]?.addresses?.digitalAddresses?.[0]?.emailAddresses || [];

    const emaNumbers = telecoms
      .map((x: any) => x?.number)
      .filter(Boolean)
      .map((num: string) => num.replaceAll(/\s+/g, ""));

    const emaEmails = emails
      .map((x: any) => x?.value)
      .filter(Boolean);

    const emaNumbersText =
      isUnknownEma || emaNumbers.length === 0 ? "-" : emaNumbers.join(", ");

    const emaEmailsText =
      isUnknownEma || emaEmails.length === 0 ? "-" : emaEmails.join(", ");

    return (
      <>
        <TableRow className="flex items-center bg-white">
          <TableCell role="none" className="w-2/3 p-3 firstcol">
            <div role="none" className="text-base padding-new color_black global-txt">
              {t("EMA_numbers")}
            </div>
          </TableCell>
          <TableCell role="none" className="w-2/3 p-0 secondcol">
            <div role="none" className="text-base padding-new color_black global-txt">
              {emaNumbersText}
            </div>
          </TableCell>
          <TableCell role="none" className="w-2/3 p-3 thirdcol paddright">
            <div role="none" className="edt-spc padding-new text-right pr-8">
              {""}
            </div>
          </TableCell>
        </TableRow>

        <TableRow className="flex items-center bg-white">
          <TableCell role="none" className="w-2/3 p-3 firstcol">
            <div role="none" className="text-base padding-new color_black global-txt">
              {t("EMA_emails")}
            </div>
          </TableCell>
          <TableCell role="none" className="w-2/3 p-0 secondcol">
            <div role="none" className="text-base padding-new color_black global-txt">
              {emaEmailsText}
            </div>
          </TableCell>
          <TableCell role="none" className="w-2/3 p-3 thirdcol paddright">
            <div role="none" className="edt-spc padding-new text-right pr-8">
              {""}
            </div>
          </TableCell>
        </TableRow>
      </>
    );
  };

  const showDMQuestionnaireResponses = () =>
    isDMReportPreferenceEnabled && //Configs
    (
      hasSORToSkipCausingDMQues || //Currently PRODAMP only
      (
        !!workOrderObject?.isCausingDampAndMould && //Covers property logic and question is shown only to Properties
        (
          !isAdditionalDMWorkOrderRequired || //Multi DM WO feature toggle config
          (isUndefinedNullOrEmpty(workOrderObject.associatedWorkOrdersIdentifier) && !hasExistingDMCaseOrWO)
        )
      )
    )
  const MultiWOConditions = () =>
    !!isDmcEnabledFlag && //Configs
    (
      hasSORToSkipCausingDMQues || //Currently PRODAMP only
      (
        !!workOrderObject?.isCausingDampAndMould && //Covers property logic and question is shown only to Properties
        (
          !isAdditionalDMWorkOrderRequired || //Multi DM WO feature toggle config
          (isUndefinedNullOrEmpty(workOrderObject.associatedWorkOrdersIdentifier) && !hasExistingDMCaseOrWO)
        )
      )
    )
  const isEligibleForDMInspectionMultiWO = () =>
    !hasSORToSkipCausingDMQues && !!isAdditionalDMWorkOrderRequired && //Configs
    (!(assetDetails?.statuses?.isInDefects === true && workOrderObject?.isVandalism !== true)
      || (assetDetails?.statuses?.isInDefects === true && workOrderObject?.isVandalism === false
        && workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.High))
    && MultiWOConditions();

  function setParamsForDMCCreateWO(dmcWorkOrderObject: any) {
    let siteIdentifier = null;
    let isEMA = false
    let contractorPhone = null;
    let _dMCWOContractorResponse = dMCWOContractorResponse?.[0];
    if (_dMCWOContractorResponse) {
      siteIdentifier = _dMCWOContractorResponse?.contractorSites?.[0] ?? null;
      isEMA = !!_dMCWOContractorResponse?.statuses?.isEMA;
    }
    if (_dMCWOContractorResponse?.addresses?.digitalAddresses?.[0]?.telecomsAddresses?.length > 0) {
      contractorPhone = _dMCWOContractorResponse?.addresses?.digitalAddresses?.[0]?.telecomsAddresses?.[0]?.number;
    }


    dmcWorkOrderObject.isDraft = false;
    dmcWorkOrderObject.isEmergency = dMCWOPriorityResponse?.repairPriority === RepairPriorityCode.DampAndMouldEmergency;
    dmcWorkOrderObject.isOutOfHours = dMCWOPriorityResponse?.isWorkingHour === 'Y' ? false : true;
    dmcWorkOrderObject.isEMA = isEMA
    dmcWorkOrderObject.isSupplementary = false;
    dmcWorkOrderObject.isVandalism = false;
    dmcWorkOrderObject.isPotentialDuplicate = false;
    dmcWorkOrderObject.isSubmitted = true;
    dmcWorkOrderObject.isCausingDampAndMould = false;
    dmcWorkOrderObject.isVulnerable = null;
    dmcWorkOrderObject.VulnerableResponseText = null;
    dmcWorkOrderObject.worksOrderIdentifier = "";
    dmcWorkOrderObject.jobNo = "";
    dmcWorkOrderObject.contractor = siteIdentifier;
    dmcWorkOrderObject.contractorName = _dMCWOContractorResponse?.name;
    dmcWorkOrderObject.contractorPhoneNumber = contractorPhone;
    dmcWorkOrderObject.originalWorkOrderIdentifier = workOrderObject.id;
    dmcWorkOrderObject.caseIdentifier = "";
    dmcWorkOrderObject.repairLocationId = locationID;
    dmcWorkOrderObject.trade = "";
    dmcWorkOrderObject.repairCause = "General Wear and Tear";
    dmcWorkOrderObject.repairCauseId = RepairCauseId[workOrderObject.repairCause as keyof typeof RepairCauseId];
    dmcWorkOrderObject.sorCode = "PRODAMP";
    dmcWorkOrderObject.repairReason = "Investigate Damp or Mould";
    dmcWorkOrderObject.description = "Investigate Damp or Mould";
    dmcWorkOrderObject.additionalInformation = "";
    dmcWorkOrderObject.priority = dMCWOPriorityResponse?.repairPriority;
    dmcWorkOrderObject.associatedWorkOrdersIdentifier = workOrderObject.id;
    dmcWorkOrderObject.associatedWorkOrdersJobNumber = "";
    dmcWorkOrderObject.associatedWorkOrdersType = "DampAndMould";
    dmcWorkOrderObject.assessmentInformation = workOrderObject.assessmentInformation;
    dmcWorkOrderObject.smv = null;
    dmcWorkOrderObject.elementCode = "REPINTREP"
    dmcWorkOrderObject.repairType = "repair";
    dmcWorkOrderObject.workProgramme = "RESP";
    dmcWorkOrderObject.surveyReason = null;
  };

  const dmcAggregator = async () => {
    const dmcWorkOrderObject = { ...workOrderObject };
    try {
      setParamsForDMCCreateWO(dmcWorkOrderObject);

      const _worksOrderRequest = new WorksOrderRequest(dmcWorkOrderObject);
      const woRequestParameters = _worksOrderRequest.updateWorkOrderParameter(dmcWorkOrderObject);
       woRequestParameters.isHHSRSHazard = null; // Passing isHHSRSHazard null for DMC workorder
       woRequestParameters.hhsrsAssessment = undefined; // Passing hhsrsAssessment undefined for DMC workorder

      let createDMInspectionResp: any;

      createDMInspectionResp = await api.createWorkOrderRepair({ ...woRequestParameters });
      const loc = createDMInspectionResp?.location;
      const idFromLocation = loc?.split("/")?.[4];
      if (idFromLocation) {
        dmcWorkOrderObject.id = idFromLocation;
        dmcWorkOrderObject.worksOrderIdentifier = idFromLocation;
        dispatch(dmcWorkOrderRepairObject(dmcWorkOrderObject));
      }
      const handle = pollJobNumber({
        workOrderId: dmcWorkOrderObject?.id,
        timeoutMs: WOCreationTimeoutSeconds * 1000,
        delayMs: WOCreationPollingDelaySeconds * 1000,
        immediateFirstAttempt: false,
      });

      try { pollAbortRef.current?.(); } catch { }
      pollAbortRef.current = handle.abort;

      const { repair } = await handle.promise;
      pollAbortRef.current = null;
      const dmJobNo = (repair?.jobNo || "").trim();
      if (dmJobNo) {
        const [serialNumber, sequenceNumber] = dmJobNo.split("/", 2).map((s: string) => s.trim());
        dmcWorkOrderObject.jobNo = dmJobNo;
        dmcWorkOrderObject.contractorName = dMCWOContractorResponse?.[0]?.name || dmcWorkOrderObject.contractorName;
        if (repair.caseIdentifier) dmcWorkOrderObject.caseIdentifier = repair.caseIdentifier;
        if (repair.premisesType) dmcWorkOrderObject.premisesType = repair.premisesType;
        dispatch(dmcWorkOrderRepairObject(dmcWorkOrderObject));
        //Dont need to await note addition
        addDMReportPreferenceNote(serialNumber, sequenceNumber);
      } else {
        dispatch(
          woFailureCase(
            Helper.WOFailureMethod.DmcGetJobNumber,
            t("DMC_Failed_JobNumber_Msg")
          )
        );
      }
    } catch (e) {
      dispatch(
        woFailureCase(
          Helper.WOFailureMethod.DmcAggregator,
          t("DMC_Failed_Multi_WorkOrder_Msg")
        )
      );
      console.error("dmc Aggregator failed", e);
    }
    return dmcWorkOrderObject;
  };

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;

    window.scrollTo(0, 0);
    try {
      setdisabled(true);
      setIsLoading(true);

      const eligibilityTask = (async () => {
        try {
          if (workOrderObject?.isPotentialDuplicate === true) {
            dispatch(userChosenDuplicateQuestion(t("I don't think this is a duplicate")));
          }
          if (workOrderObject?.isVulnerable === true) {
            dispatch(userChosenVulnerabilityQuestion("Yes"));
          }
          const enhancedRepairEligibilityPayload = {
            priority: workOrderObject?.priority,
            sor: userChosenSOR,
            isPotentialDuplicate: getIsPotentialDuplicate(),
            isVulnerable: getIsVulnerable(),
            channel: "ColleagueSelfService",
            userRoles: localStorage.getItem('user_role') || ""
          };
          const repairEnhancedEligibility = await api.postEnhancedRepairEligibility(enhancedRepairEligibilityPayload);
          if (repairEnhancedEligibility?.isEligible === false) {
            setShowError(t(repairEnhancedEligibility?.errorCode));
            setDisableContinueforEnhancedEligiblityCheck(true);
            dispatch(isSaveAndExitAllowed(true));
          } else if (repairEnhancedEligibility?.isEligible === true) {
            dispatch(isSaveAndExitAllowed(false));
          }
          const parsedData = Object.entries(savedAnswerKeys).reduce(
            (prev: any, curr: any) => {
              let mainData: any = {};
              const schemaBaseKey = curr?.[0];
              if (
                (schemaBaseKey !== "Advanced_RepairRole_Emergency_Header_Text" && schemaBaseKey !== "Repair_Emergency_Header_Text") ||
                (schemaBaseKey === "Advanced_RepairRole_Emergency_Header_Text" && choosePriorityOfRepairPermission) ||
                (schemaBaseKey === "Repair_Emergency_Header_Text" && !choosePriorityOfRepairPermission)
              ) {
                const combinedData = Object.entries(curr[1]);
                combinedData.forEach(([key, value]: any) => {
                  if (savedResponses[value] || key === "urlPath") {
                    mainData = {
                      ...mainData,
                      [curr[1]["urlPath"]]: {
                        ...mainData[curr[1]["urlPath"]],
                        [key]:
                          key === "urlPath"
                            ? value
                            : {
                              key: value,
                              value: savedResponses[value],
                            },
                      },
                    };
                  }
                });
              }
              return {
                ...prev,
                ...mainData,
              };
            },
            {}
          );
          dispatch(updatePrevConfirmedState(parsedData));
        } catch (e) {
          console.error(e);
          props.history.push("/GenericError");
        }
      })();

      const mainInitTask = (async () => {
        try {
          setIsContractorLoading(true);
          let determineDMInspectionContractorAndPriority = isEligibleForDMInspectionMultiWO();
          //do not call contractor determination in case of triage
          let isTriageCase = false;
          if (
            !isNullOrUndefined(userChosenDuplicateQuestionFromStore) ||
            (!isNullOrUndefined(userChosenVulnerabilityAdditionalInformation)
              && !vulnerabilityExcludedSorcodes?.includes(userChosenSOR))) {
            isTriageCase = !reviewTriageRepairPermission;
          }
          setIsTriage(isTriageCase);
          const isAnaTypeValue = customerAdditionalAlertData?.length > 0 ? true : false;
          const sorCode = userChosenSOR;

          let tenureCode = "";
          if (customerResponse?.tenanciesSummaries.length > 1) {
            const tenancySummary = customerResponse?.tenanciesSummaries?.filter(
              (tenancy: any) =>
                tenancy?.tenancySummary?.tenancyEndDate === null
            );
            tenureCode = tenancySummary?.[0]?.tenancySummary?.tenancyTenureCode;
          }
          else {
            tenureCode = customerResponse?.tenanciesSummaries?.[0]?.tenancySummary?.tenancyTenureCode;
          }
          const selectedSor =
            sorCode !== ""
              ? selectedRepairReasonObject?.[0]?.sors?.find(
                  (sor: any) => sor?.sorCode === sorCode
                )
              : selectedRepairReasonObject?.[0]?.sors?.[0];

          const priorityWorkProgramme = IsRecall
            ? workOrderObject?.workProgramme
            : selectedSor?.workProgramme;
            
          const isPreAssessmentHazardOutcome =
            selectedRepairReasonObject?.[0]?.isPreAssessmentRequired === true &&
           isHHSRSAssessmentCompleted;
          const defaultPriorityIsEmergency = [
            RepairPriorityCode.Emergency,
            "Emergency",
            "Emergency (OOH)",
          ].includes(selectedRepairReasonObject?.[0]?.priority);

          // The AR1 selected priority is only honoured for a user holding the AR1 role.
          // For any other colleague the priority selector is never shown, so the
          // repair default applies.
          const selectedPriorityIsEmergency = (isAR1User && isPreAssessmentHazardOutcome)
            ? defaultPriorityIsEmergency 
            : workOrderObject?.isEmergency;
            
          const priorityIsEmergency = isPreAssessmentHazardOutcome
            ? defaultPriorityIsEmergency
            : selectedPriorityIsEmergency;
         
          const tasks = [];
          let commonContractorDeterminationResponse = null;
          let commonPriorityResponse = null;
          const priorityCode = !isHHSRSAssessmentCompleted && priorityIsEmergency
            ? RepairPriorityCode.Emergency
            : priorityCodeValue;
          const isEmergencyOverride = getIsEmergencyOverride(
            priorityCodeValue,
            priorityIsEmergency
          );

          const originalWoPayload = {
            repairId: workOrderObject?.id,
            priorityCode,
            repairType: sorCode,
            region: assetDetails?.region,
            sorCode: userChosenSOR,
            repairTime: new Date().getHours().toString(),
            uprn: assetDetails?.uprn,
            raisedDate: moment(new Date()).format("YYYY-MM-DDTHH:mm:ss"),
            repairCauseId: userVandalismChoice === "Yes" ? 4 : 1,
            maintenanceResponsibility: userMaintResp,
            repairResponsibility: userSelectedRepairResp,
            borough: assetDetails?.borough ? assetDetails?.borough?.trim() : "",
            isVandalism: workOrderObject?.isVandalism && userVandalismChoice === "Yes" ? true : false,
            isEmergency: isEmergencyOverride,
            description: workOrderObject?.repairReason,
            isVulnerable: userChosenVulnerabilityQuestionFromStore === 'Yes',
            assessmentInformation: workOrderObject?.assessmentInformation,
            isRecall: IsRecall,
            isAnaType: isAnaTypeValue,
            tenureCode: tenureCode,
            isV14Upgradable: isEnhancedDiagnosticsRepair ? repairDiagnosticData?.isV14Eligibile : selectedRepairReasonObject?.[0]?.isV14Upgradable,
            workProgramme: isEnhancedDiagnosticsRepair ? repairDiagnosticData?.workProgram : priorityWorkProgramme,
            premisesType: assetDetails?.assetType,
            riskRating: workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating,
            type: workOrderObject?.assessmentInformation?.outcome?.type
          };

          if (IsRecall) {
            //Recall contractor and priority logic
            const { commonPriorityResponse: recallPriority } = await getRecallContractorAndPriority(workOrderObject, originalWoPayload, customerDetails);
            commonPriorityResponse = recallPriority;
            if (commonPriorityResponse) {
              workOrderObject.priority = commonPriorityResponse?.repairPriority;
            }
          }
          else {
            if (!isTriageCase) {
              // Add the original work order payload to the tasks array
              const isCatalystDefectRepair = isCatalystDefectTriageCase === true ? (dmcInspectionSorCodes?.includes(userChosenSOR)
                && workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.High) ? false : true : false;
              tasks.push(getContactorAndRepairPriority(originalWoPayload, isCatalystDefectRepair, "repair"));
            }
            else {
              tasks.push(null);
            }

            if (determineDMInspectionContractorAndPriority) {
              // Create payload for damp/mould investigation WO
              const adjustedRiskRating = workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating;
              let dampMouldPriorityCode = originalWoPayload.priorityCode;

              if (adjustedRiskRating === CasePriority.High) {
                dampMouldPriorityCode = RepairPriorityCode.DampAndMouldEmergency;
              } else if (adjustedRiskRating === CasePriority.Medium) {
                dampMouldPriorityCode = RepairPriorityCode.DampAndMouldSignificant;
              } else if (adjustedRiskRating === CasePriority.Low) {
                dampMouldPriorityCode = RepairPriorityCode.DampAndMouldLowRisk;
              }
              const dampMouldWoPayload = {
              ...originalWoPayload,
              priorityCode:dampMouldPriorityCode,
              isEmergency: workOrderObject?.assessmentInformation?.outcome?.adjustedRiskRating === CasePriority.High,
              isVandalism: false,
              sorCode: "PRODAMP",
              repairType: "PRODAMP",
              description: "Damp and Mould Investigation",
              repairResponsibility: repairResp,
              isV14Upgradable: false
            };
              // Add the damp/mould work order payload to the tasks array
              tasks.push(getContactorAndRepairPriority(dampMouldWoPayload, false, "dmc"));
            }
            // Execute both API calls concurrently
            const [originalWOResponses, dampMouldWOResponses] = await Promise.all(tasks);
            commonContractorDeterminationResponse = originalWOResponses?.determinedContractorResp;
            commonPriorityResponse = originalWOResponses?.updatedRepairPriorityResp;

            // Handle responses for damp/mould multi work order
            // We will NOT attmpt DM Inspection, if Original WO has Tier 2 contractor
            if (dampMouldWOResponses && commonContractorDeterminationResponse?.[0]?.id !== catalystTriageContractorType.CATALYST_TRIAGE_TIER2) {
              setDMCWOContractorResponse(dampMouldWOResponses.determinedContractorResp);
              setDMCWOPriorityResponse(dampMouldWOResponses.updatedRepairPriorityResp);
              dispatch(getDMCDeterminedContractorDetails(dampMouldWOResponses.determinedContractorResp));
            }
          }
          // get contractor priority and check if OOH
          if (commonContractorDeterminationResponse) {
            const contractorDetail = commonContractorDeterminationResponse?.[0];
            setIsCatalystTriageTier2OrEma(contractorDetail?.id === catalystTriageContractorType.CATALYST_TRIAGE_TIER2 || contractorDetail?.id === catalystTriageContractorType.CATALYST_TRIAGE_EMA);
            setContractorDeterminationResponse(contractorDetail);
            dispatch(getContractorName(contractorDetail?.name));
            dispatch(getContractorPayload({
              determinedContractorResponse: commonContractorDeterminationResponse,
              priorityCode,
            }));
            dispatch(getDeterminedContractorDetails(commonContractorDeterminationResponse));
            const sorcode = userChosenSOR; // to be replaced when hot water US done on HL desc page
            if (contractorDetail && workOrderObject !== undefined && workOrderObject !== null) {
              workOrderObject.contractorName = contractorDetail?.name;
              if (contractorDetail?.contacts?.[0]?.addresses?.digitalAddresses?.[0]?.telecomsAddresses?.length > 0) {
                workOrderObject.contractorPhoneNumber =
                  contractorDetail?.contacts?.[0]?.addresses?.digitalAddresses?.[0]?.telecomsAddresses?.[0]?.number;
              }
              if (sorcode !== "") workOrderObject.sorCode = sorcode;
              const siteIdentifier = contractorDetail?.contractorSites
                ? contractorDetail?.contractorSites?.[0]
                : null;
              workOrderObject.contractor = siteIdentifier;

              userChosenSupplementaryQuestionsVal === "Yes"
                ? (workOrderObject.isSupplementary = true)
                : userChosenSupplementaryQuestionsVal === "No"
                  ? (workOrderObject.isSupplementary = false)
                  : (workOrderObject.isSupplementary = null);

              userChosenVandalismQuestionVal === "Yes" && assetDetails?.statuses?.isInDefects === true && vandalismConfigValue === true
                ? (workOrderObject.isVandalism = true)
                : userChosenVandalismQuestionVal === "No" && assetDetails?.statuses?.isInDefects === true && vandalismConfigValue === true
                  ? (workOrderObject.isVandalism = false)
                  : (workOrderObject.isVandalism = null);

              userChosenCovidQuestionVal === "Yes" && covidConfigValue
                ? (workOrderObject.isCovidSelfIsolated = true)
                : userChosenCovidQuestionVal === "No" && covidConfigValue
                  ? (workOrderObject.isCovidSelfIsolated = false)
                  : (workOrderObject.isCovidSelfIsolated = null);

              userChosenDuplicateQuestionFromStore === "" && workOrderObject?.isPotentialDuplicate !== true
                ? (workOrderObject.isPotentialDuplicate = false)
                : (workOrderObject.isPotentialDuplicate = !duplicateOverridePermissions);
              (userChosenVulnerabilityQuestionFromStore !== "" &&
                userChosenVulnerabilityQuestionFromStore !== null &&
                userChosenVulnerabilityQuestionFromStore === "Yes") || workOrderObject?.isVulnerable === true
                ? (workOrderObject.isVulnerable = !hideVulnerablePagePermission)
                : (workOrderObject.isVulnerable = false);
              userChosenVulnerabilityAdditionalInformation !== "" && !hideVulnerablePagePermission
                ? (workOrderObject.VulnerableResponseText =
                  userChosenVulnerabilityAdditionalInformation)
                : (workOrderObject.VulnerableResponseText = null);

              if (userChosenSOR !== "") {
                workOrderObject.sorCode = userChosenSOR;
              } else {
                workOrderObject.sorCode = "NA"
              }

              if (isCatalyst) {
                workOrderObject.isCatalyst = true;
              }
              workOrderObject.isInDefect = assetDetails?.statuses?.isInDefects
              if (isPreAssessmentHazardOutcome) {
                workOrderObject.isEmergency = isEmergencyOverride;
              }
              workOrderObject.isOutOfHours = commonPriorityResponse?.isWorkingHour === 'Y' ? false : true;
              workOrderObject.priority = commonPriorityResponse?.repairPriority;
              const _worksOrderRequest = new WorksOrderRequest(
                workOrderObject
              );
              const woRequestParameters =
                _worksOrderRequest.updateWorkOrderParameter(workOrderObject);

              woRequestParameters.originalWorkOrderIdentifier = workOrderObject?.originalWorkOrderIdentifier
              await api.updateWorkOrderRepair(
                woRequestParameters,
                workOrderObject?.id,
                "eTag"
              );
              dispatch(workOrderRepairObject(workOrderObject));
            }
          }
        } catch (e) {
          console.error(e);
        }
        finally {
          setIsContractorLoading(false);
        }
      })();

      (async () => {
        await Promise.allSettled([eligibilityTask, mainInitTask]);
        setdisabled(false);
        setIsLoading(false);
      })();
    } catch (e) {
      console.error(e);
    }
    return () => {
      try { pollAbortRef.current?.(); } catch { }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      {isLoadingWOcreation ? (
        <div className="loader-div">
          <div className="loader-text">{t("Repair_request_loader_text1")}</div>
          <div className="">{t("Repair_request_loader_text2")}</div>
          <LoadingSpinner />
        </div>
      ) : (
        <div>
          <Container id="confirmation-container" role="main" className="ctn-fht">
            <div id="confirmation-back-div" className="container mx-auto mb-0 md:mb-14 lg:mb-10 px-0 xl:px-0" >
              <p id="confirmation-p" className="text-teal text-xl mt-4 mb-8">
                <button className="back-btn" data-testid="confirmationBackBtn" onClick={backButtonHandler}>
                  <i className="fas fa-angle-left mr-2"></i>
                  {t("back")}
                </button>
              </p>
            </div>

            <div className="mb-16 container">
              <div id="confirmation-main-div" className="global-txt">
                <h2 id="confirmation-h1" className="text-purple-100 text-2xl mb-2">
                  {t("Repair_Details_Head")}
                </h2>
                {disableContinueforEnhancedEligiblityCheck && (
                  <div
                    data-testid="alert-warning"
                    className="error mb-8 sm:mx-1"
                    role="alert"
                    placeholder="alert-message"
                  >
                    <div className="w-full px-2 py-2 bg-yellow flex items-center">
                      <div className="px-4 pr-8">
                        <i className="fas fa-exclamation-triangle text-brick-70 w-6 h-6"></i>
                      </div>
                      <div className="flex items-center">
                        <p
                          data-testid="locatioAlert_0"
                          className="w-full text-left my-2 font-AvantGardeGothic-Md"
                        >
                          {" "}
                          {t(showError)}
                        </p>
                      </div>
                    </div>
                  </div>
                )}

                {!disableContinueforEnhancedEligiblityCheck && (
                  <>
                    <p id="confirmation-p1" className="mb-4 color_black">
                      {t("Repair_Details_Text1")}{' '}
                      <i className="fas fa-edit text-teal text-lg"></i>{' '}
                      {t("Repair_Details_Text3")}
                    </p>
                    <p id="confirmation-p2" className="mb-4 color_black">
                      {t("Repair_Details_Text2")}
                    </p>
                  </>
                )}
              </div>

              {isLoading ? (
                <Loader
                  type="ThreeDots"
                  color="#00BFFF"
                  height={50}
                  width={50}
                  timeout={0}
                />
              ) : (
                <div className="repair-text " id="confirmation-div-table">
                  <ReactBootstrap.Table striped className="container-new">
                    <TableBody
                      role="presentation"
                      id="confirmation-table"
                      className="w-full border border-grey"
                    >
                      <th className="hidden">{t("table_heading")}</th>
                      {Object.entries(savedAnswerKeys)
                        .filter((e: any) => {
                          // Hide repair_reason_question if repair type is ED
                          if (isEnhancedDiagnosticsRepair && e?.[0] === "repair_reason_question") {
                            return false;
                          }
                          if (
                            (e[1].reduxKey === "mediaAttached" &&
                              isRepairMedia === "false")
                          ) {
                            return false;
                          }
                          if (
                            hideVulnerablePagePermission &&
                            (e[1].reduxKey === "userChosenVulnerabilityQuestion" ||
                              (e[1].reduxKey === "userChosenEmergencyQuestion" && e[1].urlPath === "RepairEmergency"))
                          ) {
                            return false;
                          }

                          if (e[1].reduxKey === "userChosenEmergencyQuestion") {
                            const emergencyAnswer = savedResponses[e[1]?.reduxKey];
                            const hasEmergencyAnswer =
                              !isUndefinedNullOrEmpty(emergencyAnswer) &&
                              !(typeof emergencyAnswer === "string" && emergencyAnswer.trim() === "");

                            if (e[1].urlPath === "RepairLocation") {
                              // Emergency Dropdown from Repair Reason-Location page, only valid for AR1 roles
                              return choosePriorityOfRepairPermission && hasEmergencyAnswer;
                            } else if (e[1].urlPath === "RepairEmergency") {
                              // Emergency Radio selection from emergency page, only valid for non-AR1 roles, ,ie. 
                              return !choosePriorityOfRepairPermission && assetDetails?.assetType === "Property"
                                && selectedRepairReasonDefaultPriority === "Emergency" && !dmcInspectionSorCodes?.includes(userChosenSOR) && hasEmergencyAnswer;
                            }
                          }
                          if (isHHSRSEnabled && isHHSRSRole && !IsRecall) {
                            if (e[1].reduxKey === "saveHHSRSOptionValue") {
                              return isHhsrsOption();
                            }
                            if (e[1].reduxKey === "saveHazardType") {
                              return hhsrsOption && !isNullOrUndefined(hhsrsCategory) && hhsrsCategory;
                            }
                            if (e[1].reduxKey === "saveSaverityScore") {
                              return hhsrsOption && !isNullOrUndefined(hhsrsSeverity) && hhsrsSeverity;
                            }
                          }
                          if ((e[1]?.urlPath === "VandalismQuestion" && assetDetails?.statuses?.isInDefects === true && vandalismConfigValue === true) || e[1]?.urlPath !== "VandalismQuestion") {
                            if ((e[1]?.urlPath === "CovidQuestion" && covidConfigValue) || e[1]?.urlPath !== "CovidQuestion") {
                              if ((e[1]?.urlPath === "VulnerabilityQuestion" && priority !== "Emergency") || e[1]?.urlPath !== "VulnerabilityQuestion") {
                                if (e[1]?.reduxKey === "userChosenPropertyType") {
                                  return (assetDetails?.assetType || "");
                                }
                                return savedResponses[e[1]?.reduxKey];
                              }
                            }
                          }
                        })
                        .map((item: any, idx: number, arr: any[]) => {
                          if (
                            item?.[0] === "confirmation_diagnostics_block_title"
                            && isEnhancedDiagnosticsRepair
                          ) {
                            return (
                              <TableRow key="confirmation_diagnostics_block_title">
                                <TableCell className="w-2/3 p-3 firstcol">
                                  <div className="text-base color_black global-txt">
                                    {t("repair_diagnostics_overview")}
                                  </div>
                                </TableCell>
                                <TableCell className="w-2/3 p-0 secondcol" colSpan={1}>
                                  <div className="text-base color_black global-txt">
                                    <div className="mb-2">
                                      <span style={{ fontWeight: "bold", marginLeft: 0 }}>{t("diagnostics_problem_category")} </span>
                                      <span style={{ fontWeight: "normal", marginLeft: 0 }}>
                                        {repairDiagnosticFinalData?.problemCategory ?? ""}
                                      </span>
                                    </div>
                                    <div className="mb-2">
                                      <span style={{ fontWeight: "bold", marginLeft: 0 }}>{t("diagnostics_problem")} </span>
                                      <span style={{ fontWeight: "normal", marginLeft: 0 }}>
                                        {repairDiagnosticFinalData?.problem ?? ""}
                                      </span>
                                    </div>
                                    {!isNullOrUndefined(repairDiagnosticFinalData?.diagnosticQuestions) && repairDiagnosticFinalData?.diagnosticQuestions?.map((q: any) => (
                                      <div key={nanoid()} className="mb-2">
                                        <span style={{ fontWeight: "bold", marginLeft: 0 }}>{q.title} </span>
                                        <span style={{ fontWeight: "normal", marginLeft: 0 }}>{q.answer}</span>
                                      </div>
                                    ))}
                                    <div className="mb-2">
                                      <span style={{ fontWeight: "bold", marginLeft: 0 }}>{t("diagnostics_repair_diagnosis")}</span>
                                      <span style={{ display: "inline-block", width: 1 }} />
                                      <span style={{ fontWeight: "normal", marginLeft: 0 }}>
                                        {savedResponses?.userChosenHighLevelDescription ?? ""}
                                      </span>
                                    </div>
                                  </div>
                                </TableCell>
                                <TableCell className="w-2/3 p-3 thirdcol paddright">
                                  <div
                                    className="edt-spc padding-new text-right pr-8"
                                    style={{
                                      height: "100%",
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "flex-end"
                                    }}
                                  >
                                    <i
                                      data-testid="diagnosis-edit-icon"
                                      className="fas fa-edit text-teal text-lg cursor-pointer"
                                      title={t("confirmation_edit")}
                                      onClick={() => {
                                        setIsEditModalOpen(true);
                                        setEditUrl(`/${item[1]?.urlPath}`);
                                      }}
                                      onKeyDown={e => {
                                        if (e.key === "Enter" || e.key === " ") {
                                          setIsEditModalOpen(true);
                                          setEditUrl(`/${item[1]?.urlPath}`);
                                        }
                                      }}
                                    />
                                  </div>
                                </TableCell>
                              </TableRow>
                            );
                          }
                          return renderData(item, idx);
                        })}
                      {displayContractorName()}
                      {displayDMCCheck()}
                      {renderDMCQuestionAnswers()}
                      {displayDMCEmailReport()}
                      {displayDMCContractorName()}
                      {displayEMAContactDetails()}
                    </TableBody>
                  </ReactBootstrap.Table>
                </div>
              )}
            </div>
            <div
              id="confirmation-main-btn"
              className="flex justify-between items-center pb-4 md:pb-8 container"
            >
              <ExitModalAndSave
                id="confirmation-exitmodal"
                exit={exitButtonHandler}
                saveDraftAndExit={saveDraftAndExit}
                closeAfterSaving={closeAfterSaving}
              />

              <Button
                id="btn_confirmation"
                disabled={disabled || disableContinueforEnhancedEligiblityCheck}
                onClick={callPageHandler}
                className="button-class"
              >
                {t("continuen_button")}
                <i className="fas fa-angle-right relative text-white pointer-events-none arrow"></i>
              </Button>
            </div>

            <ExitModalAndSave
              id="confirmation-edit-exitmodal"
              open={isEditModalOpen}
              modalTitle={<span style={{ color: "#A64CA6", fontWeight: 600 }}>
                {t("confirmation_edit_modal_title")}
              </span>}
              modalSubtitle={t("confirmation_edit_modal_subtitle")}
              stayButtonText={t("confirmation_edit_modal_stay")}
              leaveButtonText={t("confirmation_edit_modal_leave")}
              onClose={() => setIsEditModalOpen(false)}
              onLeave={() => {
                setIsEditModalOpen(false);
                props.history.replace(editUrl);
              }}
              showBackOnly={true}
            />
          </Container>
        </div>
      )}
    </div>
  );
};
export default ConfirmationDetails;
